/**
 * AuditorLocked — «Te explicamos cómo mejorar exactamente tu posicionamiento».
 *
 * Reutiliza `ProLockedSection`, que ya resuelve lo difícil de un muro con
 * cristal: el reclamo va en un hermano `absolute` (si se mete dentro, el blur
 * se lo come), el bloque desenfocado lleva `inert` + `aria-hidden` (el
 * desenfoque es cosmético: sin eso se tabula hasta dentro y un lector de
 * pantalla lo lee entero) y el aviso de «ejemplo» se pinta DENTRO del cristal.
 *
 * **Lo borroso es de EJEMPLO, y tiene que serlo.** `blur-sm` es una clase de
 * CSS: se quita con dos clics en el inspector. Si ahí abajo estuvieran las
 * recomendaciones reales de SU negocio, estaríamos regalando justo lo que
 * cobramos. Y si fueran de ejemplo sin decirlo, el que quitara el cristal se
 * creería que esas cifras son las suyas. Por eso `sampleLabel`.
 *
 * La forma —dos tarjetas, verde y ámbar, con título y descripción por ítem— es
 * la de `CustomerThemes`, que es lo que de verdad va a ver cuando entre.
 */
import { AlertTriangle, ThumbsUp } from 'lucide-react';

import ProLockedSection from '@/components/gbusiness/ProLockedSection';

export default function AuditorLocked({ c, ctaId, onUpgrade }) {
  const l = c.locked;

  return (
    <ProLockedSection
      locked
      title={l.title}
      description={l.description}
      cta={l.cta}
      ctaId={ctaId}
      onUpgrade={onUpgrade}
      sampleLabel={l.sampleLabel}
    >
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-4">
        <ThemeCard title={l.lovesTitle} items={l.loves} tone="positive" />
        <ThemeCard title={l.improvesTitle} items={l.improves} tone="negative" />
      </div>
    </ProLockedSection>
  );
}

function ThemeCard({ title, items, tone }) {
  const isPositive = tone === 'positive';
  const cardStyle = isPositive
    ? 'bg-emerald-50/60 border-emerald-200'
    : 'bg-amber-50/60 border-amber-200';
  const headerStyle = isPositive ? 'text-emerald-700' : 'text-amber-700';
  const Icon = isPositive ? ThumbsUp : AlertTriangle;

  return (
    <div className={`rounded-2xl border p-5 ${cardStyle}`}>
      <div className={`flex items-center gap-2 mb-4 ${headerStyle}`}>
        <Icon className="w-4 h-4" />
        <span className="font-semibold text-sm">{title}</span>
      </div>
      <div className="space-y-3">
        {(items || []).map((item, i) => (
          <div key={i}>
            <p className="font-semibold text-slate-900 text-sm leading-snug">{item.title}</p>
            <p className="text-xs text-slate-500 mt-0.5 leading-relaxed">{item.description}</p>
          </div>
        ))}
      </div>
    </div>
  );
}
